import { Injectable, inject } from '@angular/core';
import { singleConnect } from '@core/utils';
import type { NgxsOnInit, StateContext } from '@ngxs/store';
import {
	Action,
	State,
	StateToken,
	createPropertySelectors,
} from '@ngxs/store';
import { patch } from '@ngxs/store/operators';

import { PortalUsersRepo } from '../portalUsers.firebase.repo';

import type { PortalUsersStateModel } from './portalUsers.firebase.models';
import {
	SetPortalUsers,
	SetPortalUsersConnection,
} from './portalUsers.firebase.actions';

export const STATE_TOKEN = new StateToken<PortalUsersStateModel>(
	'clientPortalUsers',
);

export const $PROPS = createPropertySelectors(STATE_TOKEN);

export const PORTAL_USERS_STATE_DEFAULTS: PortalUsersStateModel = {
	query: {
		connected: true,
	},
	items: [],
};

@State<PortalUsersStateModel>({
	name: STATE_TOKEN,
	defaults: PORTAL_USERS_STATE_DEFAULTS,
})
@Injectable()
export class PortalUsersState implements NgxsOnInit {
	private repo = inject(PortalUsersRepo);
	static _props = $PROPS;

	ngxsOnInit(): void {
		singleConnect(
			PortalUsersState._props.query,
			() => this.repo.getAll(),
			(data) => {
				return new SetPortalUsers(data);
			},
		);
	}

	@Action(SetPortalUsersConnection)
	setUsersClientPortalConnection(
		ctx: StateContext<PortalUsersStateModel>,
		action: SetPortalUsersConnection,
	): void {
		ctx.setState(patch({ query: patch({ connected: action.connect }) }));
	}

	@Action(SetPortalUsers)
	setUsersClientPortal(
		ctx: StateContext<PortalUsersStateModel>,
		{ items }: SetPortalUsers,
	): void {
		ctx.patchState({
			items,
		});
	}
}
